module.exports = __webpack_public_path__ + "static/media/workcom-square.dab18a4a.jpg";